"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var MessageBar_1 = require("office-ui-fabric-react/lib/MessageBar");
var ValidationErrors_styles_1 = require("./ValidationErrors.styles");
var ValidationErrors_className_1 = require("./ValidationErrors.className");
var ValidationErrors = /** @class */ (function (_super) {
    __extends(ValidationErrors, _super);
    function ValidationErrors() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._renderError = function (error, idx) {
            return (React.createElement(MessageBar_1.MessageBar, { key: idx, className: _this._classNames.error, messageBarType: MessageBar_1.MessageBarType.error },
                error.keyTitle ? React.createElement("label", { className: _this._classNames.errorLabel },
                    error.keyTitle,
                    ": ") : undefined,
                error.message));
        };
        return _this;
    }
    ValidationErrors.prototype.render = function () {
        this._classNames = ValidationErrors_className_1.getClassNames(ValidationErrors_styles_1.getStyles(null, this.props.styles), this.props.className);
        if (this.props.errors && this.props.errors.length > 0) {
            var errors = this.props.errors.map(this._renderError);
            return (React.createElement("div", { className: this._classNames.root }, errors));
        }
        return null;
    };
    return ValidationErrors;
}(React.Component));
exports.ValidationErrors = ValidationErrors;
